export default __webpack_public_path__ + "static/media/logo-light.71597ad9.png";